var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cookie-law',{attrs:{"theme":"gwf","transitionName":"fade","storageType":"cookie","message":_vm.message,"buttonText":_vm.buttonText}})
}
var staticRenderFns = []

export { render, staticRenderFns }